
import BCXIcon from '@/components/molecules/BCXIcon.vue';
import BCXPanel from '@/components/molecules/BCXPanel.vue';
import useMessengerState from '@/state/messenger/messengerState';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BCXMessengerNewChatPanel',
  components: { BCXIcon, BCXPanel },
  emits: ['close-panel'],
  setup(_, { emit }) {
    const { startNewChat, openChatgroupPanel } = useMessengerState();

    const startPrivateChat = () => {
      startNewChat();
      emit('close-panel');
    };

    const startChatgroup = () => {
      openChatgroupPanel();
      emit('close-panel');
    };

    return {
      startPrivateChat,
      startChatgroup
    };
  },
});
